import * as zod from 'zod';

export default zod.object({
  currentIteration: zod.number().int().nonnegative(),
  expectedTotalIterations: zod.number().positive().optional(),
});
